import { atom } from 'jotai'

export const workspaces = atom([])
export const activeWorkspace = atom(null)
export const workspacesLoading = atom(false)
export const workspacesLoaded = atom(false)
export const workspacesError = atom(null)
export const workspaceMembers = atom({ members: [], invitations: [] })
export const membersLoading = atom(false)
